const MilestoneData=[
{Name:"Part Ordered", Status:1},
{Name:"Part Received", Status:1},
{Name:"Vessel/Agent Contacted", Status:2},
{Name:"Engineer Assigned", Status:0},
{Name:"Engineer Dispatched", Status:0},
{Name:"Engineer Waiting", Status:0},
{Name:"Engineer Travelling", Status:0},
]
export default MilestoneData;